import { differenceInSeconds } from 'date-fns';

export const calculateProgress = (
    startDate: Date,
    endDate: Date,
    currentTime: Date = new Date(),
): number => {
    if (!startDate || !endDate) {
        return 0;
    }

    const diffProgram = differenceInSeconds(endDate, startDate);
    if (diffProgram <= 0) return 0;

    const diffCurrentTime = differenceInSeconds(currentTime, startDate);
    const percentage = Math.ceil((diffCurrentTime / diffProgram) * 100);

    return Math.min(100, Math.max(0, percentage));
};
